import { render, staticRenderFns } from "./PromotionType.vue?vue&type=template&id=7b5cf84b&scoped=true&"
import script from "./PromotionType.vue?vue&type=script&lang=js&"
export * from "./PromotionType.vue?vue&type=script&lang=js&"
import style0 from "./PromotionType.vue?vue&type=style&index=0&id=7b5cf84b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cf84b",
  null
  
)

export default component.exports